import { render } from "./ReviewPeriodCell.vue?vue&type=template&id=ab384128&scoped=true"
import script from "./ReviewPeriodCell.vue?vue&type=script&lang=js"
export * from "./ReviewPeriodCell.vue?vue&type=script&lang=js"

import "./ReviewPeriodCell.vue?vue&type=style&index=0&id=ab384128&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab384128"]])

export default __exports__